module.exports = __webpack_public_path__ + "img/menu-dingwei.d1abb7ca.png";